import axios from 'axios';
import { MDBTreeview, MDBTreeviewItem } from 'mdb-react-treeview';
import { MDBBtn, MDBContainer, MDBIcon, MDBInputGroup, MDBSelect } from 'mdb-react-ui-kit';
import React, { useContext, useEffect, useState } from 'react';
import { UserProfileContext } from '../../context/UserProfileProvider';
import { fetchRoles } from '../../utils/Common';
const RoleManager = () => {
  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);
  const [newGroup, setNewGroup] = useState([]);
  const [error, setError] = useState('');
  const inventoryUrl = process.env.REACT_APP_INVENTORY_URL;
  const { groups } = useContext(UserProfileContext);
  useEffect(() => {
    fetchRoles(setRoles,setError);
  }, []);

 

  const handleAddGroup = async () => {
    // Ensure a role is selected and new groups are added
    if (!selectedRole) {
      setError('Please select a role.');
      return;
    }
    if (!newGroup || !newGroup.length) {
      setError('Please select one or more groups to add.');
      return;
    }
  
    try {
      // Ensure `groups` is defined and fallback to an empty array if not
      const currentGroups = selectedRole.groups?.map((g) => g.groupDn) || [];
      const updatedGroups = [...currentGroups, ...newGroup]; // Combine current and new groups
  
      await axios.put(`${inventoryUrl}/users/roles/update-groups`, {
        roleDn: selectedRole.dn,
        groupDns: updatedGroups,
      });
  
      setNewGroup([]); // Reset selected groups
      fetchRoles(); // Refresh the roles
    } catch (err) {
      console.error('Error adding groups:', err);
      setError('Failed to add groups to role. Please try again.');
    }
  };
  

  const handleRemoveGroup = async (groupDnToRemove) => {
    if (!selectedRole) return;

    try {
      const updatedGroups = selectedRole.groups
        .filter((g) => g.groupDn !== groupDnToRemove)
        .map((g) => g.groupDn);

      await axios.put(`${inventoryUrl}/users/roles/update-groups`, {
        roleDn: selectedRole.dn,
        groupDns: updatedGroups,
      });

      fetchRoles(); // Refresh the roles
    } catch (err) {
      console.error('Error removing group:', err);
      setError('Failed to remove group from role. Please try again.');
    }
  };

  const handleDeleteRole = async (roleDn) => {
    try {
      await axios.delete(`${inventoryUrl}/users/roles/${roleDn}`);
      fetchRoles(); // Refresh the roles
    } catch (err) {
      console.error('Error deleting role:', err);
      setError('Failed to delete role. Please try again.');
    }
  };

  return (
    <MDBContainer className='align-items-center justify-content-center'>
     

      {error && <p className="text-danger">{error}</p>}

      {/* Display Roles in Tree */}
      <MDBTreeview>
      {roles?.length > 0 ? (
    roles.map((role) => (
          <MDBTreeviewItem 
            key={role.dn}
            name={
              <div className='mb-2'>
                <MDBIcon icon="user-circle" fas /> {role.name}{' '}
                <MDBBtn
                  color="danger"
                  size="sm"
                  className="ms-2"
                  onClick={() => handleDeleteRole(role.dn)}
                >
                  <MDBIcon fas icon="minus-circle" />Role
                </MDBBtn>
              </div>
            }
            subtree
            show
            onClick={() => setSelectedRole(role)}
          >
            {role?.groups?.map((group) => (
              <MDBTreeviewItem className='mb-2'
                key={group.groupDn}
                name={
                  <>
                    <MDBIcon icon="users" fas /> {group.groupName}{' '}
                    <MDBBtn
                      color="danger"
                      size="sm"
                      className="ms-2"
                      onClick={() => handleRemoveGroup(group.groupDn)}
                    >
                      <MDBIcon fas icon="minus-circle" />Group
                    </MDBBtn>
                  </>
                }
              />
            ))}
          </MDBTreeviewItem>
        ))
      ) : (
        <p>Loading roles...</p>
      )}
    </MDBTreeview>

      {/* Selected Role Details */}
      {selectedRole && (
        <div className="mt-4">
          <h5>Manage Groups for Role: {selectedRole.name}</h5>

          {/* Add New Group */}
          {/* <MDBInputGroup className="d-flex align-items-center">
            <MDBInput
              label="New Group DN"
              value={newGroup}
              onChange={(e) => setNewGroup(e.target.value)}
              className="me-2"
            />
            <MDBBtn onClick={handleAddGroup}><MDBIcon fas icon="plus-circle" />Group</MDBBtn>
          </MDBInputGroup> */}
<MDBInputGroup style={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
<MDBSelect
  responsive
  className="custom-dropdown"
  wrapperClass="w-100"
  label="Group"
  data={groups} // Array of { text: groupName, value: groupDn }
  search
  multiple
  onValueChange={(selectedOptions) => {
    const valuesOnly = selectedOptions.map(option => option.value); // Extract values
    setNewGroup(valuesOnly); // Set only the values (group DNs)
  }}
  style={{ height: '100%' }}
/>

  <MDBBtn
    onClick={handleAddGroup}
    style={{ height: '100%' }}
  >
    <MDBIcon fas icon="plus-circle" /> Group
  </MDBBtn>
</MDBInputGroup>


        </div>
      )}
    </MDBContainer>
  );
};

export default RoleManager;
